import axios from 'axios';
import { auth } from '../firebase/config';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use(async (config) => {
    const usuario = auth.currentUser;
    if (usuario) {
        const token = await usuario.getIdToken();
        // Adiciona o token ao cabeçalho Authorization
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;